import { HOST_PORTAL_URL } from '@/services/connections.service';

const getPartnersBasicInfoURL = () => `${HOST_PORTAL_URL}/partners/basic-info`;

export default getPartnersBasicInfoURL;
